let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6zIKH")).then(() => parcelRequire('7kihW'));